// extracted by mini-css-extract-plugin
export default {"root":"Input__root___MWZ1Y"};